import Video from './Video';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'Video',
  ClassComponent: Video
});